var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 0.5,
    y: 0.5,
    fill: "#FFEDEE",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8A0000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M50 28v9.333c0 4.347 0 6.52-.662 8.25a9.983 9.983 0 0 1-5.734 5.753C41.879 52 39.712 52 35.379 52c-2.272 0-3.408 0-4.466-.233a9.955 9.955 0 0 1-4.365-2.19c-.82-.708-1.502-1.62-2.865-3.444l-6.008-8.036a3.393 3.393 0 0 1 .064-4.144 3.367 3.367 0 0 1 5.02-.28l3.243 3.254V21a3 3 0 1 1 6 0m0 0v-4a3 3 0 0 1 6 0v4m-6 0v9m6-9a3 3 0 0 1 6 0v4m-6-4v9m6-5a3 3 0 0 1 6 0v5m-6-5v5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.43471a50ebbee8b6ab6c481d2b454482.svg";
export { ForwardRef as ReactComponent };